import { Box, Stack } from '@mui/material'
import { Project } from 'api'

import {
  DeleteProjectBlock,
  ProjectPlaceholdersBlock,
  UnsubscribeBlock,
} from '../'
import { LinkedProjectBlock } from '../linked-project-block'
import { ProjectIndentBlock } from '../project-indent-block'
import { ProjectInfoBlock } from '../project-info-block'

export const ProjectSettingsTabContent = ({
  project,
  isOwner,
}: {
  project: Project
  isOwner: boolean
}) => {
  const {
    name,
    avatarUrl,
    description,
    projectId,
    placeholders,
    linkedProject,
    type,
    indent,
  } = project

  return (
    <Box width={1} mx="auto">
      {isOwner ? (
        <Stack spacing={2.5}>
          <ProjectInfoBlock
            projectId={projectId}
            name={name}
            description={description}
            type={type}
            avatarSrc={avatarUrl ?? ''}
          />

          <ProjectPlaceholdersBlock
            projectId={projectId}
            placeholders={placeholders}
          />

          <LinkedProjectBlock
            projectId={projectId}
            linkedProjectName={linkedProject?.name}
          />

          <ProjectIndentBlock projectId={projectId} indent={indent} />

          <DeleteProjectBlock projectId={projectId} projectName={name} />
        </Stack>
      ) : (
        <UnsubscribeBlock projectId={projectId} projectName={name} />
      )}
    </Box>
  )
}
